import React from 'react';
import ReactDOM from 'react-dom'
import GTip from '../../component/gTip'
import Footer from '../../component/footer'
import SubmitForm from './component/submitForm'
import {
    AppContext
} from '../../config/context'
import '../../common/util/polyfill'

class App extends React.Component {
    constructor() {
        super()
        this.state = {
        }
    }

    render() {
        return <AppContext.Provider value={this.state}>
            <SubmitForm></SubmitForm>
            <Footer></Footer>
            <GTip></GTip>
        </AppContext.Provider>
    }
}

ReactDOM.render(<App />, document.getElementById('dokodemodoa'))